import store from '../client-redux/store';

export const getLanguageName = (langId?: number): string => {
  let langSettings = store.getState().lang?.langSettings;
  let found;
  if (langSettings) {
    found = langSettings.find(element => element.langid === langId);
  }
  return found ? found.nativeName :  `lang_${langId}`;
};